const apiHeader = () => {
    return {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
}

export const reqHeader = {
    apiHeader
}